import Vue from 'vue';
import { MutationTree } from 'vuex';
import { DiscussionState } from './state';
import { FileModel } from '@/models/FileModel';

const mutations: MutationTree<DiscussionState> = {
  SET_FORUM_API_DISCUSSIONS(state, entities: DiscussionState) {
    if (!entities.discussions) return;

    Object.values(entities.discussions).forEach((discussion) => {
      Vue.set(state.discussions, discussion.id.toString(), {
        ...state.discussions[discussion.id],
        ...discussion,
      });
    });
  },

  SET_FORUM_API_PAGINATED_DISCUSSIONS(state, entities: DiscussionState) {
    if (!entities.discussions) {
      state.paginatedDiscussions = {};
      return;
    }

    Object.values(entities.discussions).forEach((discussion) => {
      Vue.set(state.paginatedDiscussions, discussion.id.toString(), discussion);
    });
  },

  DELETE_FORUM_DISCUSSION(state, payload: { discussionId: string }) {
    const { discussionId } = payload;

    Vue.delete(state.discussions, discussionId);
    return true;
  },

  UPDATE_FORUM_DISCUSSION(
    state,
    payload: { text: string; discussionId: string; attachments: FileModel[] },
  ) {
    const { text, attachments, discussionId } = payload;
    const { discussions, paginatedDiscussions } = state;

    Vue.set(discussions, discussionId.toString(), {
      ...discussions[discussionId],
      text,
      attachments,
    });

    if (paginatedDiscussions) {
      Vue.set(paginatedDiscussions, discussionId.toString(), {
        ...paginatedDiscussions[discussionId],
        text,
        attachments,
      });
    }
  },
};

export default mutations;
